import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import parser from 'html-react-parser'

export default function Video4({data}) {
    const {video4Title, video4Url, video4Icon} = data
    return (
        <div className='our-imapct-video-wrap'>
            <div className='container imapct-vid-cont yt-video-cont'>
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        <figure className='our-impact-icon'>
                            <GatsbyImage image={getImage(video4Icon?.localFile)} alt='image' />                            
                        </figure>
                        <h2 className='heading-level-4-i text-uppercase green-color-1'>
                            {video4Title && parser(video4Title)}
                        </h2>
                    </div>
                    <div className='imapact-vid-sec mb-0'>
                        <iframe
                            width='560'
                            height='488'
                            src={`https://www.youtube.com/embed/${video4Url}`}
                            title='YouTube video player'
                            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                            allowFullScreen
                        ></iframe>
                    </div>
                </div>
            </div>
        </div>
    )
}
